import { RM07_01 } from "./RM07_01";

export const RM07 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "advancedGauge",
        "colorTheme": 'colorTheme1',
        "title": "CALL REACH",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "title": "Title",
                "value": 'Progress',
                "total": 'Total',
                "endpoint": "RM07",
                "parameters": [
                    { key: "CycleCode", value: "CP1" },
                    { key: "CycleYear", value: "2026" },
                    { key: "RegionCode", value: "RS3" },
                ]
            },
            "context": {
                "point": {
                    "onClick": RM07_01
                }
            }
        }
    }
}